import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        py: 2,
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
          © {currentYear} ООО "Проявление-Тех"
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: { xs: 'center', sm: 'right' } }}>
          Поддержка:{' '}
          <Link href="mailto:mail@yavlenie.pro" underline="hover" color="inherit">
            mail@yavlenie.pro
          </Link>
          {' | '}
          Полностью сделано ИИ
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;